// 考试练习

// 练习首页
const ExerciseIndex = r => require.ensure(
  [],
  () => r(require('@/components/bloom-test/exercise/index')),
  'ExerciseIndex'
)

// 练习试卷
const ExercisePaper = r => require.ensure(
  [],
  () => r(require('@/components/bloom-test/exercise/paper')),
  'ExercisePaper'
)

// 练习报告
const ExerciseEnd = r => require.ensure(
  [],
  () => r(require('@/components/bloom-test/exercise/end')),
  'ExerciseEnd'
)

export default [
  // 练习首页
  {
    path: '/ExerciseIndex',
    name: 'ExerciseIndex',
    component: ExerciseIndex
  },
  // 练习试卷
  {
    path: '/ExercisePaper',
    name: 'ExercisePaper',
    component: ExercisePaper
  },
  // 练习报告
  {
    path: '/ExerciseEnd',
    name: 'ExerciseEnd',
    component: ExerciseEnd
  }
]
// {
// path: '/ExerciseIndex',
// name: 'ExerciseIndex',
// component: () =>
// import(/* webpackChunkName: "exercise" */ '@/components/bloom-test/exercise/index')
// },
// // 练习试卷
// {
// path: '/ExercisePaper',
// name: 'ExercisePaper',
// component: () =>
// import(/* webpackChunkName: "exercise" */ '@/components/bloom-test/exercise/paper')
// },
// // 练习结束
// {
// path: '/ExerciseEnd',
// name: 'ExerciseEnd',
// component: () =>
// import(/* webpackChunkName: "exercise" */ '@/components/bloom-test/exercise/end')
// }



// WEBPACK FOOTER //
// ./src/router/sub-route/bloom-test.js